import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import PreviewsPdf from '../../Atoms/PreviewsPdf/PreviewsPdf';

// * put this in a general file
const cutWord = (word, maxLength = 0) => {
  if (!word) return 'Brochure';
  if (word.length < maxLength) return word;
  return word.substring(0, maxLength)?.concat('...');
};

const ModalPreviewCV = ({
  show,
  setShow,
  pdfFile,
  title,
  subtitle,
  confirm,
  cancel,
  onClickConfirm = () => {},
  onClickCancel = () => {},
  size = null,
  ...props
}) => {
  useEffect(() => {
    if (
      show &&
      (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i) ||
        window.innerWidth < 780)
    ) {
      window.open(pdfFile?.file);
      setShow(false);
      return;
    }
  }, [show]);
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="contained-modal-title-vcenter"
      size={size ?? 'xl'}>
      <Modal.Header
        closeButton
        className="jobs-modal-header"
        style={{
          padding: '1rem 2rem 0',
          backgroundColor: 'white',
          color: 'black',
          border: 'none'
        }}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="d-flex flex-column text-center mx-auto w-100">
          <h3 className="title-modal-st my-0" style={{ fontSize: '24px' }}>
            {title}
          </h3>
          <p className="subtitle-modal-st"> {subtitle}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: '80vh' }}>
          <PreviewsPdf title="cv" docPDF={pdfFile?.file} />
        </div>
        <div className="d-flex justify-content-around align-items-center">
          {confirm && (
            <button
              className="btn btn-block yellow"
              style={{ width: props.widthBtns ?? '48%', border: 'none' }}
              onClick={onClickConfirm}>
              {confirm}
            </button>
          )}
          {cancel && (
            <button
              className="btn btn-block yellow"
              style={{ width: props.widthBtns ?? '48%', border: 'none' }}
              onClick={onClickCancel}>
              {cancel}
            </button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPreviewCV;
